import styles from './Avatar.module.css';

interface AvatarProps {
  name: string;
  size?: number;
  hue?: number;
}

function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function Avatar({ name, size = 28, hue = 38 }: AvatarProps) {
  const initials = initialsOf(name);
  return (
    <span
      className={styles.avatar}
      aria-label={name}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        background: `oklch(94% 0.04 ${hue})`,
        // L=38% keeps initials >=4.5:1 across every hue (hue 210 / blue was 3.x at L=48%)
        color: `oklch(38% 0.14 ${hue})`,
        borderColor: `oklch(88% 0.06 ${hue})`,
      }}
    >
      {initials}
    </span>
  );
}
